import Vue from "vue";
import Vuex from "vuex";
import { getRoles } from "@/services/endpoints/roles";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import auth from "./auth";
import user from "./user";
import location from "./location";
import validation from "./validation";
import insurance from "./insurance";
import general from "./general";
import service from "./service";
import sections from "./sections";
import units from "./units";
import configs from "./configs";
import breadcrumb from "./breadcrumb";
import permissions from "./permissions";
// import doctor from "./doctor";
import patient from "./patient";
import holiday from "./holidays";
import receptions from "./receptions";
import indications from "@/store/Indications";
import reports from "@/store/reports";
import medicalSpecialties from "@/store/medicalSpecialties";
import createPersistedState from "vuex-persistedstate";
import serviceGroups from "@/store/serviceGroups";
import countries from "@/store/countries";
import cities from "@/store/cities";
import permissionRooms from "@/store/permissionRooms";
import legacyField from "@/store/patient/legacyField";
import webServiceVersions from "@/store/webServiceVersions";
import absenceUsers from "@/store/absenceUsers";
import legalReferenceNotifications from "@/store/legalReferenceNotifications";
import plan from "@/store/plan";
import siteSettings from "@/store/siteSettings";
import message from "@/store/message";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    auth,
    user,
    location,
    validation,
    insurance,
    general,
    service,
    sections,
    units,
    configs,
    patient,
    receptions,
    indications,
    reports,
    medicalSpecialties,
    breadcrumb,
    permissions,
    serviceGroups,
    countries,
    cities,
    permissionRooms,
    legacyField,
    webServiceVersions,
    absenceUsers,
    legalReferenceNotifications,
    plan,
    siteSettings,
    message,
    holiday
  },
  state: {
    roles: [],
    isLoading: false,
  },
  mutations: {
    SET_ROLES: (state, payload) => {
      state.roles = payload;
    },
    SET_IS_LOADING: (state, payload) => {
      state.isLoading = payload;
    },
  },
  getters: {
    roles: (state) => {
      return state.roles;
    },
    isLoading: (state) => {
      return state.isLoading;
    },
  },
  actions: {
    async getRoles({ commit }) {
      try {
        let res = await getRoles();
        if (res.data) {
          commit("SET_ROLES", res.data);
          return res.data;
        }
      } catch (err) {
        throw new Error(err);
      }
    },
  },
  plugins: [
    createPersistedState({
      paths: ["breadcrumb"],
    }),
  ],
  strict: process.env.DEV,
});
